import React from 'react';

class DateQuestion extends React.Component {
  constructor(props){
    super(props);
    this.state= { value: props.predefinedValue};
    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  onChangeHandler(e){
    const {value} = e.target;
    const {field} = this.props;
    this.setState({value:  value});
    this.props.handleChangeListener(field, value, null, null, null);
  }

  getDateOnFormatAAAAMMDDFromString = (date) => {
    if(date === null || date === undefined){
      return null;
    }
    const dateParts = date.split('-');
    const returnData = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
    return returnData;
  } 

  render() {
    const {field, text, note, predefinedValue, errors, isError, value} = this.props;
    const errorList = errors !== null? errors.map( (error) =>  <li key={error}>{error}</li>) : null;
    const formatedDate = this.getDateOnFormatAAAAMMDDFromString(predefinedValue);
    return (
      <div className="pregunta">
          <div className="form-group">
              <label htmlFor={field}>{text}</label>
              <input 
                name={field} 
                type="date" 
                className="form-control"
                defaultValue={formatedDate}
                placeholder={"dd/mm/aaaa"}
                onChange={this.onChangeHandler}
                value={value}
                />
              <p className="question-subinstruction">{note}</p>
              {isError === true ? 
                <ul className="error">
                  {errorList}
                </ul>
                : null
              }        
          </div>
      </div>
    );
  }
}

export default DateQuestion;



// WEBPACK FOOTER //
// ./src/views/Forms/Patient/QuestionsTypes/DateQuestion.js